"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M12 8l-1.2 2.796-2.8 1.2 2.8 1.197L12 16l1.2-2.807L16 12l-2.8-1.204zM5 0L3.5 3.5 0 4.995 3.5 6.5 5 10l1.5-3.5L10 5 6.5 3.5z"];
//# sourceMappingURL=clean.js.map